import AllMenu from 'assets/svg/all-menu/all-menu-color.svg'
import Button from 'common/components/Button'
import Image from 'common/components/Image'
import Skeleton from 'common/components/Skeleton'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import redirect from 'lib/common/redirect'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const Section = styled.div`
  width: ${theme.layout.containerWidth};
  max-width: 1200px;
  margin: 0 auto;
`

const CategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: auto repeat(4, 1fr);
  gap: 12px;
  align-items: center;

  > * > span {
    text-align: left;
  }
`

const CategoryName = styled.span`
  font-size: 13px;
  color: ${(props) => props.theme.colors.grayDark};
  font-weight: 500;
`

const StyledMenu = styled(AllMenu)`
  margin-right: 8px;
  color: ${theme.colors.redOrange};
`

const CategoryButton = styled(Button)`
  min-height: 60px;
  border-color: ${theme.colors.blue};

  &:hover {
    border-color: ${theme.colors.redOrange};
    background: ${theme.colors.grayLighter};
  }
`

const CategorySkeleton = styled(Skeleton)`
  height: 60px;
`

interface CategoryItem {
  categoryName?: string
  categoryImage?: string
  categoryRedirectUrl?: string
}

interface ProductCategoriesSectionProps {
  categories?: CategoryItem[]
}

const ProductCategoriesSection = ({
  categories,
}: ProductCategoriesSectionProps): JSX.Element => {
  const { t } = useTranslation('common')

  return (
    <Section>
      <CategoriesGrid>
        <CategoryButton
          variant="outlined"
          withIcon={{
            icon: <StyledMenu />,
            position: 'left',
          }}
          height="60px"
          color="grayLight"
          padding="0 10px"
          block
          onClick={() =>
            redirect(`${WEB_DESKTOP_RALALI_URL}/all-categories`)
          }
        >
          <CategoryName>{t('ALL_CATEGORIES')}</CategoryName>
        </CategoryButton>

        {!categories?.length &&
          new Array(4)
            .fill(null)
            .map((_, index) => (
              <CategorySkeleton
                key={`cat-skel-${index.toString()}`}
              />
            ))}

        {categories?.map((category) => (
          <CategoryButton
            key={category.categoryName}
            variant="outlined"
            withIcon={{
              icon: (
                <Image
                  src={category.categoryImage}
                  width="36px"
                  height="36px"
                  objectFit="contain"
                />
              ),
              position: 'left',
            }}
            height="60px"
            color="grayLight"
            padding="0 10px"
            block
            onClick={() => redirect(category.categoryRedirectUrl)}
          >
            <CategoryName>{category.categoryName}</CategoryName>
          </CategoryButton>
        ))}
      </CategoriesGrid>
    </Section>
  )
}

export default ProductCategoriesSection
